import React from 'react';
import { CheckCircle2Icon, ZapIcon, BookOpenIcon, EyeIcon, ShieldIcon, SunIcon, GiftIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function OfferSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-gradient-to-b from-[#2a1f14] via-[#33261a] to-[#2a1f14] text-white py-20 px-4 relative overflow-hidden" data-id="element-105">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#c9a96e]/5 rounded-full blur-[120px] pointer-events-none" data-id="element-106" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-107">
        <div className="text-center mb-12" data-id="element-108">
          <div className="inline-flex items-center gap-2 bg-[#b5634b] text-white px-5 py-2 rounded-full font-oswald font-bold text-sm uppercase tracking-widest mb-6" data-id="element-109">
            <ZapIcon className="w-4 h-4" data-id="element-110" />
            Oferta Especial
          </div>
          <h2 className="font-oswald text-4xl md:text-6xl font-bold uppercase tracking-tight mb-4" data-id="element-111">
            Todo esto puede ser tuyo <span className="text-[#c9a96e]" data-id="element-112">hoy</span>
          </h2>
          <p className="font-opensans text-xl text-gray-300" data-id="element-113">
            Mira todo lo que recibirás con tu acceso inmediato:
          </p>
        </div>

        <div className="bg-[#3d2e20] border border-[#5a4535] rounded-2xl p-8 md:p-10 mb-12 shadow-2xl" data-id="element-114">
          <h3 className="font-oswald text-2xl md:text-3xl font-bold text-[#c9a96e] uppercase mb-8 text-center" data-id="element-115">
            Esto es lo que incluye tu Mega Pack:
          </h3>

          <ul className="space-y-5 mb-8" data-id="element-116">
            {[{
            icon: BookOpenIcon,
            text: 'Tomo 1 — Entiende tu mente',
            sub: 'Descubre por qué la mente genera sobrepensamiento'
          }, {
            icon: EyeIcon,
            text: 'Tomo 2 — Observa tus pensamientos',
            sub: 'Aprende a observar sin reaccionar automáticamente'
          }, {
            icon: ShieldIcon,
            text: 'Tomo 3 — Domina tu mundo interior',
            sub: 'Desarrolla estabilidad mental y control emocional'
          }, {
            icon: SunIcon,
            text: 'Tomo 4 — El camino hacia la verdadera paz mental',
            sub: 'La enseñanza final para vivir con una mente más tranquila'
          }, {
            icon: GiftIcon,
            text: 'BONUS: Ejercicios prácticos diarios',
            sub: 'Prácticas simples para reducir el estrés y calmar tu mente — ¡GRATIS!'
          }].map((item, i) => <li key={i} className="flex items-start gap-4 bg-[#2a1f14]/50 p-4 rounded-xl border border-[#5a4535]/50" data-id="element-117">
                <div className="bg-[#c9a96e]/10 p-2 rounded-lg flex-shrink-0 mt-1" data-id="element-118">
                  <item.icon className="w-6 h-6 text-[#c9a96e]" data-id="element-119" />
                </div>
                <div data-id="element-120">
                  <p className="font-oswald text-lg md:text-xl font-bold text-white uppercase" data-id="element-121">
                    {item.text}
                  </p>
                  <p className="font-opensans text-sm md:text-base text-gray-400 mt-1" data-id="element-122">
                    {item.sub}
                  </p>
                </div>
              </li>)}
          </ul>

          <div className="border-t border-[#5a4535] pt-6 mt-6" data-id="element-123">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-124">
              {['Acceso inmediato y de por vida', 'Descarga digital instantánea', 'Explicaciones claras y simples', 'Prácticas aplicables desde el día 1', 'Sin técnicas complicadas', 'Resultados desde la primera lectura'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-125">
                  <CheckCircle2Icon className="w-5 h-5 text-[#7a9e7a] flex-shrink-0" data-id="element-126" />
                  <span className="font-opensans text-base text-gray-200" data-id="element-127">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </div>

        <div className="text-center mb-10" data-id="element-128">
          <p className="font-opensans text-lg text-gray-400 mb-2" data-id="element-129">
            Valor total del programa:
          </p>
          <p className="font-oswald text-4xl md:text-5xl text-gray-500 line-through decoration-[#b5634b] decoration-4 mb-4" data-id="element-130">
            $39.990
          </p>
          <p className="font-opensans text-lg text-gray-300 mb-4" data-id="element-131">
            Precio especial por tiempo limitado:
          </p>
          <div className="inline-block bg-gradient-to-r from-[#c9a96e] to-[#b8944f] text-[#2a1f14] px-10 py-6 rounded-2xl shadow-[0_0_40px_rgba(201,169,110,0.3)]" data-id="element-132">
            <p className="font-oswald text-6xl md:text-8xl font-bold leading-none" data-id="element-133">
              $13.990
            </p>
          </div>
          <p className="font-oswald text-xl md:text-2xl text-[#7a9e7a] font-bold mt-6 uppercase tracking-wide" data-id="element-134">
            ¡Ahorras $26.000 hoy!
          </p>
        </div>

        <div className="text-center" data-id="element-135">
          <div className="cursor-pointer mb-8 inline-block group" onClick={scrollToCompra} data-id="element-136">
            <img src="https://cdn.magicpatterns.com/uploads/4mZ4LNCUAzk91huCv93jrq/va.jpg" alt="Mega Pack Claridad Mental" className="mx-auto max-w-full md:max-w-md rounded-xl shadow-[0_0_30px_rgba(201,169,110,0.15)] group-hover:shadow-[0_0_40px_rgba(201,169,110,0.3)] transition-all duration-300 transform group-hover:-translate-y-1" data-id="element-137" />
          </div>

          <div className="mt-4" data-id="element-138">
            <CtaButton text="QUIERO ACCEDER AL MEGA PACK AHORA" className="text-xl md:text-3xl py-6 px-10" data-id="element-139" />
          </div>

          <div className="flex flex-col md:flex-row justify-center items-center gap-4 mt-8 text-gray-400 font-opensans text-sm" data-id="element-140">
            <div className="flex items-center gap-2" data-id="element-141">
              <svg className="w-5 h-5 text-[#7a9e7a]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-142">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-143" />
              </svg>
              <span data-id="element-144">Pago 100% seguro</span>
            </div>
            <span className="hidden md:inline text-gray-600" data-id="element-145">•</span>
            <div className="flex items-center gap-2" data-id="element-146">
              <svg className="w-5 h-5 text-[#7a9e7a]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-147">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-148" />
              </svg>
              <span data-id="element-149">Acceso inmediato</span>
            </div>
            <span className="hidden md:inline text-gray-600" data-id="element-150">•</span>
            <div className="flex items-center gap-2" data-id="element-151">
              <svg className="w-5 h-5 text-[#7a9e7a]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-152">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" data-id="element-153" />
              </svg>
              <span data-id="element-154">Descarga digital</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}